import apiClient from './apiClient';

export interface NotificationPhoneResponse {
    phone: string;
    updated_at: string;
    updated_by_user_id: number | null;
}

export interface NotificationPhoneHistoryEntry {
    id: number;
    phone_before: string;
    phone_after: string;
    changed_by_user_id: number;
    changed_at: string;
}

export const getNotificationPhone = async (): Promise<NotificationPhoneResponse> => {
    const response = await apiClient.get<NotificationPhoneResponse>('/api/admin/settings/notification-phone');
    return response.data;
};

export const updateNotificationPhone = async (phone: string): Promise<{ message: string; phone: string }> => {
    const response = await apiClient.put<{ message: string; phone: string }>('/api/admin/settings/notification-phone', { phone });
    return response.data;
};

export const getNotificationPhoneHistory = async (limit?: number): Promise<{ history: NotificationPhoneHistoryEntry[] }> => {
    const response = await apiClient.get<{ history: NotificationPhoneHistoryEntry[] }>('/api/admin/settings/notification-phone/history', {
        params: limit != null ? { limit } : {},
    });
    return response.data;
};
